/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.tiposBodegas': 'Tipos  Bodegas',
'tiposBodegas.agregarTipos Bodegas': 'Create Tipos  Bodegas',
'tiposBodegas.modificarTipos Bodegas': 'Edit Tipos  Bodegas',
'tiposBodegas.eliminarTipos Bodegas': 'Delete Tipos  Bodegas',
'tiposBodegas.tipoBodegaId': 'Tipo   Bodega   Id ',
'tiposBodegas.empresaId': ' Empresa   Id ',
'tiposBodegas.tipoBodegaDescripcion': ' Tipo   Bodega   Descripcion',
'tiposBodegas.tipos Bodegas': 'Tipos  Bodegas',
'tiposBodegas.verTipos Bodegas': 'View Tipos  Bodegas',
};

